import { NgModule } from '@angular/core';
import { TimeFormatPwa } from './timeFormatPwa';

@NgModule({
  declarations: [TimeFormatPwa],
  imports: [],
  providers: [TimeFormatPwa],
  exports: [TimeFormatPwa]
})
export class TimeFormatPwaModule {
}
